import { render, staticRenderFns } from "./SbAnimation.vue?vue&type=template&id=7f568e98"
import script from "./SbAnimation.vue?vue&type=script&lang=js"
export * from "./SbAnimation.vue?vue&type=script&lang=js"
import style0 from "./SbAnimation.vue?vue&type=style&index=0&id=7f568e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports